
import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { Users, MessageCircle } from 'lucide-react';

interface Connection {
  id: string;
  full_name: string;
  avatar_url?: string;
  last_message?: string;
  last_message_time?: string;
}

interface ConnectionsListProps {
  connections: Connection[];
  selectedUser: Connection | null;
  onSelectUser: (connection: Connection) => void;
  loading: boolean;
}

const ConnectionsList: React.FC<ConnectionsListProps> = ({
  connections,
  selectedUser,
  onSelectUser,
  loading
}) => {
  return (
    <div className="bg-card/50 backdrop-blur-sm border border-primary/20 rounded-xl overflow-hidden shadow-lg">
      <div className="p-4 border-b border-primary/20 bg-gradient-to-r from-primary/10 to-primary/5">
        <div className="flex items-center gap-2">
          <Users className="h-5 w-5 text-primary" />
          <h2 className="font-semibold text-primary">Connections</h2>
        </div>
      </div>
      <div className="overflow-y-auto h-full">
        {connections.length === 0 ? (
          <div className="p-6 text-center text-muted-foreground">
            <MessageCircle className="h-12 w-12 mx-auto mb-3 text-primary/30" />
            <p className="font-medium">No connections found</p>
            <p className="text-sm">Follow users to start conversations!</p>
          </div>
        ) : (
          connections.map((connection) => (
            <div 
              key={connection.id}
              onClick={() => onSelectUser(connection)}
              className={`p-4 flex items-center cursor-pointer hover:bg-primary/5 transition-all duration-300 border-b border-border/50 ${
                selectedUser?.id === connection.id ? 'bg-primary/10 border-l-4 border-l-primary' : ''
              }`}
            >
              <Avatar className="h-12 w-12 mr-3 ring-2 ring-primary/20">
                <AvatarImage src={connection.avatar_url} />
                <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                  {connection.full_name.charAt(0)}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1">
                <p className="font-medium text-foreground">{connection.full_name}</p>
                {connection.last_message && (
                  <p className="text-xs text-muted-foreground truncate max-w-[150px]">
                    {connection.last_message}
                  </p>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ConnectionsList;
